import Bulge from './bulge.svg';
import Skew from './skew.svg';
import Trapezoid from './trapezoid.svg';

export default {
  Bulge,
  Skew,
  Trapezoid,
};
